var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTripHistoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 21,
    viewBox: "0 0 14 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.79364 3.07648V0.719238H1.95264C1.01846 0.719238 0.26001 1.4766 0.26001 2.41187V18.38C0.26001 19.3141 1.01737 20.0726 1.95264 20.0726H12.0474C12.9816 20.0726 13.74 19.3152 13.74 18.38V4.66533H11.3817C10.5064 4.66533 9.79364 3.95281 9.79364 3.07648ZM10.8642 15.0822H3.13553C3.05477 15.0822 2.9882 15.0167 2.9882 14.9348V14.3761C2.9882 14.2953 3.05368 14.2287 3.13553 14.2287H10.8653C10.9461 14.2287 11.0127 14.2942 11.0127 14.3761V14.9348C11.0116 15.0167 10.9461 15.0822 10.8642 15.0822ZM10.8642 11.8836H3.13553C3.05477 11.8836 2.9882 11.8181 2.9882 11.7362V11.1775C2.9882 11.0967 3.05368 11.0302 3.13553 11.0302H10.8653C10.9461 11.0302 11.0127 11.0956 11.0127 11.1775V11.7362C11.0116 11.8181 10.9461 11.8836 10.8642 11.8836ZM10.8642 8.68498H3.13553C3.05477 8.68498 2.9882 8.6195 2.9882 8.53765V7.9789C2.9882 7.89814 3.05368 7.83157 3.13553 7.83157H10.8653C10.9461 7.83157 11.0127 7.89705 11.0127 7.9789V8.53765C11.0116 8.6195 10.9461 8.68498 10.8642 8.68498Z",
    fill: "currentcolor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3815 3.81193H13.3536L10.646 1.10547V3.07748C10.646 3.48235 10.9756 3.81193 11.3815 3.81193Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTripHistoryIcon);
export default __webpack_public_path__ + "static/media/trip-history-icon.015b33812bdbc2f2b8cae0526bc89c02.svg";
export { ForwardRef as ReactComponent };